import Header from "components/HeaderHorizontal";
import React, { useEffect, useState, useContext } from "react";
import CardInfo from "components/CardInfo";
import "./styles.scss";
import { Link } from "react-router-dom";

import { Context } from "context/AuthContext";

import { VALIDA_QUIZ_DIA } from "services/Quiz";

const Home = () => {
  const { showLoader } = useContext(Context);
  const [loading, setLoading] = useState(false);

  const [quizRealizado, setQuizRealiado] = useState(false);
  const [userQuiz, setUserQuiz] = useState({
    name: "",
    textBody: "",
    textBtn: "",
    link: "/quiz",
  });

  useEffect(() => {
    setLoading(true);
    showLoader(true);

    const fetchQuiz = async () => {
      const data = await VALIDA_QUIZ_DIA();
      setQuizRealiado(data.value);
      setLoading(false);
      showLoader(false);
    };

    fetchQuiz();
  }, []);

  useEffect(() => {
    const loginUserData = JSON.parse(localStorage.getItem("setstate_quiz"));
    if (loginUserData) {
      setUserQuiz((prevUserQuiz) => ({
        ...prevUserQuiz,
        name: loginUserData.nome,
      }));
    }
  }, []);

  useEffect(() => {
    if (quizRealizado) {
      setUserQuiz((prevUserQuiz) => ({
        ...prevUserQuiz,
        textBody: "Você já respondeu o quiz de hoje!",
        textBtn: "Resumo",
        link: "/resumo",
      }));
    } else {
      setUserQuiz((prevUserQuiz) => ({
        ...prevUserQuiz,
        textBody: "Você tem questões para responder!",
        textBtn: "Começar",
        link: "/quiz",
      }));
    }
  }, [quizRealizado]);

  return (
    <div className="content-wrapper">
      {/* <Gamification /> */}
      <div className="home-container">
        <div className="home-content">
          <Header />

          <CardInfo
            title={
              <>
                Bem vindo de volta <br /> {userQuiz.name.split(" ").slice(0, 2).join(" ")}!
              </>
            }
            text={userQuiz.textBody}
            img=""
            link={userQuiz.link}
            textBtn={userQuiz.textBtn}
            isloading={loading}
          />
        </div>
        <div className="reporte-content">
          <p className="text-shadow">
            Encontrou algum erro? {""}
            <Link to="/reporte-erro" className="reporte-erro ms-1">
              Reporte aqui
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
